/**
 * Classificação indicativa — Lei Felca (Lei 15.211/2025, art. 8º):
 * produtos digitais de acesso provável por crianças e adolescentes devem
 * exibir a classificação indicativa COM DESTAQUE no momento do acesso.
 *
 * ⚠️ Os valores abaixo devem ser mantidos em sincronia com a classificação
 * oficial atribuída junto ao MJSP (guia de classificação indicativa) e com as
 * fichas das lojas de aplicativos. Após a remoção das caixas pagas
 * (dez/compliance), reavaliar a faixa com o MJSP — o descritor de compra de
 * item aleatório pago deixou de se aplicar.
 */
export const CONTENT_RATING = {
  /** Faixa etária (L, 10, 12, 14, 16, 18) */
  rating: "L",
  ratingLabel: "Classificação Livre",
  /** Descritores de conteúdo conforme o guia do MJSP */
  descriptors: ["Violência fantasiosa", "Compras no aplicativo", "Interação entre usuários"],
} as const;
